import { inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MediaService } from '@app/shared/services/Media.service';
import { ProductCatalogService } from '@app/shared/services/product-catalog.service';
import { catchError, of, switchMap } from 'rxjs';

@Pipe({
  name: 'ValueFromArray',
})
export class ValueFromArrayPipe implements PipeTransform {

      mediaService = inject(MediaService);
      productCatalog=inject(ProductCatalogService)
  constructor(private sanitizer: DomSanitizer) {}
  transform(
    array: any[],
    propOfValue: string,
    condition: { name: string; value: any },
    isDate: boolean = false,
    defaultValue: string | undefined = ''
  ): any {
   
    
    if (array == null || (array != null && array.length === 0)) {
      return defaultValue;
    }
    
    const row = array.find((x) => x[condition.name] == condition.value);
    if (row == null) {
      return defaultValue;
    }

    let value = row[propOfValue];
    // check if the value could be parsed into Date;

    if (value == null || value === '') {
      return defaultValue;
    } else {
      if (this.isValidDate(value) && isDate) {
        return new Date(value).toLocaleString();
      }

      //return value;
       
     return this.mediaService.getMediaByCode(value).pipe(
    catchError(() => of(null)),
    switchMap((media) => {
      if (!media) {
        return of('');
      }
      const url = this.productCatalog.createImageUrl(media);
      return of(url);
    })
  );
    }
  }
  isValidDate(value: string): boolean {
    let date = Date.parse(value);
    return !isNaN(date) && value.toString().includes('T');
  }
}
